import { render, staticRenderFns } from "./imageBlock.vue?vue&type=template&id=9c9063d8&scoped=true&"
import script from "./imageBlock.vue?vue&type=script&lang=js&"
export * from "./imageBlock.vue?vue&type=script&lang=js&"
import style0 from "./imageBlock.vue?vue&type=style&index=0&id=9c9063d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9063d8",
  null
  
)

export default component.exports